export const handleConfirmClick = (setter) => () => {
    setter((prev) => !prev);
};
